import { Box } from "@mui/material";
import Spinner from ".";

export default function MainSpinner() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        background: "rgba(255,255,255,0.8)",
      }}
    >
      <Spinner />
    </Box>
  );
}
